import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr/translation.json';
import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import de from './locales/de/translation.json';
import it from './locales/it/translation.json';
import pt from './locales/pt/translation.json';
import hi from './locales/hi/translation.json';
import zh from './locales/zh/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      es: { translation: es },
      de: { translation: de },
      it: { translation: it },
      pt: { translation: pt },
      hi: { translation: hi },
      zh: { translation: zh },
    },
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'es', 'de', 'it', 'pt', 'hi', 'zh'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Detect from localStorage, navigator, html tag
      order: ['localStorage', 'navigator', 'htmlTag', 'cookie', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
  });

export default i18n;


